<template>
	<section
		:class="['remove-margin', 'global-search-stories', {'hide-result-content' : hideByDefault}]"
		v-if="stories.length > 0"
	>
		<article
			class="global-search-single-story-container" v-for="(project, index) in getFirstThreeStories"
			:key="index"
		>
					<span
						class="global-search-result-title"
						@click="openProject(project)"
						v-html="isTitleAndMatchTextCombined ? project.referenceTitle : markKeyWord(project.referenceTitle)">
					</span>

			<p
				class="global-search-result-text"
				@click="openProject(project)"
				v-if="isTitleAndMatchTextCombined || !project.referenceTitle.toLowerCase().includes($store.getters.getGlobalSearchResult('word').toLowerCase())"
				v-html="modifyText(project.text !== undefined ? project.text : project.collection.join(', '), 100)">
			</p>

		</article>
		<button v-if="stories.length >= 2 && !hideShowAllButton" class="show-all" @click="viewAll()">
			{{ `${$t('globalSearchSections.showAll')} (${stories.length})` }}
		</button>
	</section>
</template>

<script>
import {searchFilterMixin} from "@/drc/mixins/search-filter-mixin";

export default {
	name: "GlobalSearchSingleResult",
	mixins: [searchFilterMixin],
	props: {
		stories: {
			type: Array,
			required: true
		},
		hideByDefault: {
			type: Boolean,
			required: false,
			default: true
		},
		hideShowAllButton: {
			type: Boolean,
			required: false,
			default: false
		},
		showNumberOfProjects: {
			type: Number,
			required: false,
			default: 3
		},
		matchedFilters: {
			type: Array,
			required: true
		},
		filterType: {
			type: String,
			required: false,
			default: ''
		},
		isTitleAndMatchTextCombined: {
			type: Boolean,
			required: false,
			default: true
		}
	},
	computed: {
		getFirstThreeStories() {

			return this.stories.length > this.showNumberOfProjects ? this.stories.slice(0, this.showNumberOfProjects) : this.stories;
		}
	},
	methods: {
		viewAll() {
			let url = ''
			if (this.isSearchByFilters()) {
				this.addFilters();
				url = `${this.getBaseUrl()}&${this.buildParams()}`;
			} else {
				this.text = this.$store.getters.getGlobalSearchResult('word');
				url = this.getBaseUrl()
			}

			this.$router.push(url);
		},
		isSearchByFilters(){
			return this.matchedFilters?.length > 0 && this.filterType.trim() !== ''
		},
		addFilters() {
			let ids = this.matchedFilters.map(filter => filter.id).join(',')
			this.$route.query[`${this.filterType}`] = ids;
		},
		modifyText(text, numSymbols) {
			let index = text.toLowerCase().indexOf(this.$store.getters.getGlobalSearchResult('word').toLowerCase());

			let startIndex = 0;
			let charactersCount = index + numSymbols

			if (index > numSymbols) {
				startIndex = index - numSymbols
				charactersCount = numSymbols * 2
			}

			if (text.length < numSymbols) {
				text = "..." + text + "..."
			} else {
				const wordLength = this.$store.getters.getGlobalSearchResult('word').length;
				if(index < numSymbols) {
					text = text.substr(0, charactersCount) + "...";
				} else if (index + wordLength < numSymbols) {
					text = "..." + text.substr(startIndex, charactersCount) + "...";
				} else if (index + wordLength > text.length - numSymbols) {
					text = "..." + text.substr(startIndex + wordLength, charactersCount) + "...";
				} else {
					text = "..." + text.substr(startIndex, charactersCount) + "...";
				}
			}

			return this.markKeyWord(text);
		},
		markKeyWord(text) {
			let word = this.$store.getters.getGlobalSearchResult('word').replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
			let pattern = new RegExp(word, 'i')
			let result = pattern.exec(text);
			return text.replaceAll(result, `<b class="keyword">${result}</b>`)
		},
		openProject(project) {
			let dateFormat = new Date(project.firstPublishDate);
			this.$router.push(`/projects/${dateFormat.getFullYear()}/${dateFormat.getMonth() + 1}/${project.id}`)
		},
	}
}
</script>
